import {Box} from "@chakra-ui/react";

export default function Loading() {
    return (
        <Box>Loading...</Box>
    );
}